module.exports = __webpack_public_path__ + "img/max-file-content-image-approve.6ca01359.svg";